import angular from 'angular';
import ComplianceReviewRating from './complianceReviewRating';

export default angular
  .module('components.complianceReviewRating', [])
  .component('complianceReviewRating', ComplianceReviewRating).name;
